<template>
    <div class="col-sm-12">
        <fulfillment-header>
            <template v-slot:search-input>
                <span style=" border: 1px solid #ccc; background: #fafafa; border-radius: 3px; margin: 0 5px; display: inline-block; padding: 6px 10px;">
                  Should pace at: {{ percent(staticData.pacing.should_pace_at, 0) }}
                 </span>
            </template>
        </fulfillment-header>
        <fulfillment-filters :filters="filters" :dropdowns="staticData.dropdowns" @filter="filter"/>

        <fulfillment-table
            :sort_by="sort_by"
            :sort_direction="sort_direction"
            :rows="rows"
            :sum="sum"
            :columns="columns"
            :dropdowns="staticData.dropdowns"
            @sorted="(d) => sort(d.sort_by, d.sort_direction)"
            v-loading="loading"
        ></fulfillment-table>
    </div>
</template>

<script>
import FulfillmentTable from "./fulfillment-table";
import FulfillmentHeader from "./fulfillment-header";
import FulfillmentFilters from "./fulfillment-filters";
export default {
    components: {
        FulfillmentFilters,
        FulfillmentHeader,
        FulfillmentTable
    },
    props: [
        'staticData'
    ],
    data() {
        return {
            filters: {
                'agency': [],
                'account_manager': [],
                'fulfillment_order_type': [],
                'mc_status': [],
                'ja_status': [],
                'jb_status': [],
            },
            cols: [
                'employer_id', 'employer_name', 'budget',
                'spend', 'fulfilled_percentage', 'mc_month',
                'mc_today', 'direct_month', 'direct_needed',
                'direct_today', 'mc_status', 'jobboard_status',
                'jobadviser_status', 'ff',
                'mc_percentage', 'direct_percentage'
            ],
            columns: this.staticData.available_columns,
            sort_by: 'employer_name',
            sort_direction: 'asc',

            // response data
            rows: [],
            sum: {},

            // tech
            loading: false
        };
    },
    methods: {
        select(ids) {
            this.selected = ids;
        },
        filter(filters, callback) {
            this.filters = filters;
            this.refresh().then(callback);
        },
        sort(sort_by, sort_direction) {
            this.sort_by = sort_by;
            this.sort_direction = sort_direction;

            console.log(sort_by, sort_direction);
            this.refresh();
        },
        search() {
            this.refresh();
        },
        refresh() {
            this.loading = true;
            return axios.post(url(`admin/list-fulfillment/data`), {
                columns: this.cols,
                sort_by: this.sort_by,
                sort_direction: this.sort_direction,
                filters: this.filters,
                // search_query: this.search_query
            }).then((response) => {
                this.rows = response.data.rows;
                this.sum = response.data.sum;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>
<style>
    span.ratio {
        width: 80px;
    }
    tr.inner-ff-campaign td {
        background: white;
        font-size: 0.9em;
    }
</style>